/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ChangeRequestReviewRequest({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.299 3.56A6.37 6.37 0 0 1 5.104 1.72a6.39 6.39 0 0 1 5.902 1.02 6.4 6.4 0 0 1 1.274 1.313 6.5 6.5 0 0 1 .893 1.748h1.253l-.02-.073a7.6 7.6 0 0 0-.813-1.865l-.006-.01-.004-.008a7.562 7.562 0 0 0-2.728-2.646A7.56 7.56 0 0 0 7.467.209a7.6 7.6 0 0 0-2.735.37 7.57 7.57 0 0 0-3.299 2.149l-.24-1.28A.61.61 0 0 0 .49.963a.59.59 0 0 0-.48.692l.53 2.82a.61.61 0 0 0 .701.487l2.851-.494a.59.59 0 0 0 .48-.692.61.61 0 0 0-.701-.487zM12.127 12.44a6.37 6.37 0 0 1-2.806 1.841 6.39 6.39 0 0 1-5.902-1.02 6.4 6.4 0 0 1-1.273-1.313 6.5 6.5 0 0 1-.893-1.748H0l.02.073a7.6 7.6 0 0 0 .813 1.865l.006.01.004.008q.27.444.606.854a7.6 7.6 0 0 0 2.122 1.792 7.56 7.56 0 0 0 3.388.989 7.6 7.6 0 0 0 2.735-.37 7.57 7.57 0 0 0 3.299-2.149l.24 1.279a.61.61 0 0 0 .702.487.59.59 0 0 0 .48-.692l-.53-2.82a.61.61 0 0 0-.702-.487l-2.85.494a.59.59 0 0 0-.48.692.61.61 0 0 0 .701.487z" clipRule="evenodd" /></svg>;
}
;